(function () {
    "use strict";

    angular
        .module("app")
        .service("loginModal", loginModalService)
        .component("loginModalComponent",
        { // login
            templateUrl: "src/app/login/loginModal.html",
            controller: loginModalController,
            bindings: {
                resolve: "<",
                close: "&",
                dismiss: "&"
            }
        });

    const UiState = {
        Login: "login",
        TwoFactor: "twoFactor",
        ChooseCustomer: "chooseCustomer",
        ChooseProduct: "chooseProduct",
        ForgotPassword: "forgotPassword"
    };

    /**
     * @param {ng.IHttpService} $http
     * @param {ng.ILocationService} $location
     * @param {ng.IQService} $q
     * @param {PimsSc.SessionService} session
     * @param {string} EMAIL_FORMAT
     * @param {PimsSc.StToastFactory} toast
     */
    function loginModalController($http, $location, $q, session, EMAIL_FORMAT, toast, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.emailFormat = EMAIL_FORMAT;
        $ctrl.form = {
            email: "",
            password: "",
            authCode: "",
            errorMessage: ""
        };
        $ctrl.ui = {
            state: null,
            busy: false
        };
        $ctrl.$onInit = () => {
            $ctrl.ui.state = $ctrl.resolve.initialState || UiState.Login;
        };

        $ctrl.forgotPassword = () => {
            $ctrl.form.errorMessage = "";
            $ctrl.ui.state = UiState.ForgotPassword;
        };

        $ctrl.loginContinue = form => {
            angular.extend($ctrl.form, form);
            $ctrl.ui.busy = true;
            $ctrl.form.errorMessage = "";
            $ctrl.form.email = $ctrl.form.email.trim();

            const request = {
                email: $ctrl.form.email,
                password: $ctrl.form.password
            };
            session
                .login(request)
                .then(result => {

                    if (!result.logged_in) {
                        if (result.has_error)
                            $ctrl.form.errorMessage = result.reason;
                        else
                            $ctrl.ui.state = UiState.TwoFactor;
                        return;
                    }
                    checkIfCustomerIsChosen();
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

        $ctrl.onCancel = () => {
            const logout = session.isLoggedIn ? session.logOut() : $q.resolve();
            logout.then(() => {
                $ctrl.dismiss();
                $location.path("/");
            });
        };

        $ctrl.twoFactorContinue = form => {
            angular.extend($ctrl.form, form);
            $ctrl.ui.busy = true;
            $ctrl.form.errorMessage = "";

            const request = {
                email: $ctrl.form.email,
                password: $ctrl.form.password,
                auth_code: $ctrl.form.authCode
            };
            session
                .login(request)
                .then(result => {
                    if (!result.logged_in) {
                        $ctrl.form.errorMessage = result.reason;
                        return;
                    }
                    checkIfCustomerIsChosen();
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        }

        function checkIfCustomerIsChosen() {
            if (!session.customer)
                $ctrl.ui.state = UiState.ChooseCustomer;
            else if (!session.cartTypeCode)
                setDefaultCartType().then(() => $ctrl.close());
            else
                $ctrl.close();
                //$location.path("/");
        }

        $ctrl.customerChosen = () => {
            setDefaultCartType().then(() => $ctrl.close());
            //$ctrl.ui.state = UiState.ChooseProduct; dont select product -- per muthu (login has too many steps)
            //$location.path("/");
        };

        $ctrl.productChosen = () => {
            $ctrl.close();
            //$location.path("/");
        };

        function setDefaultCartType() {
            $ctrl.ui.busy = true;
            return session
                .setCartType(CART_TYPE_CODE.RX)
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        }

        $ctrl.forgotPasswordContinue = form => {
            $ctrl.ui.busy = true;
            $http.post("/api/users/password-reset-for-email", { email: form.email })
                .then(() => $ctrl.ui.emailSent = true)
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

        $ctrl.returnToLogin = () => {
            $ctrl.form.errorMessage = "";
            $ctrl.ui.state = UiState.Login;
        }

    }
    loginModalController.$inject = ["$http", "$location", "$q", "sessionService", "EMAIL_FORMAT", "stToastFactory", "CART_TYPE_CODE"];

    /**
     * @param {ng.ui.bootstrap.IModalService} $uibModal
     */
    function loginModalService($uibModal) {
        let modal;
        return function (initialState) {
            // only open the login modal if it's not already open
            if (!modal) {
                modal = $uibModal.open({
                    component: "loginModalComponent",
                    resolve: {
                        initialState: () => initialState
                    }
                });
                modal.result.finally(() => { modal = null; });
            }
            return modal.result;
        };
    }
    loginModalService.$inject = ["$uibModal"];

})();